import { useSelector } from 'react-redux';
import { optionsSelector } from '../state/selectors';
import {
  PerformancePeriodOptionDTO,
  PortfoliosInceptionDTO,
  TransactionsSettingsDTO,
} from '../types';

interface OptionsDTO {
  portfoliosInception: PortfoliosInceptionDTO;
  performancePeriodOptions: PerformancePeriodOptionDTO[];
  transactionsSettings: TransactionsSettingsDTO;
  defaultPerformancePeriod: PerformancePeriodOptionDTO;
  customPeriodEnabled: {
    performance: boolean;
    transactions: boolean;
  };
  showGrossOfFeeDisclaimer: boolean;
  showGainLossTab: boolean;
  showIncomeTab: boolean;
}

export const useOptions = (): OptionsDTO => {
  return useSelector(optionsSelector);
};
